import './style.scss';
import 'react-notifications/lib/notifications.css';
import Skeleton from 'react-loading-skeleton';

export const SkeletonBlogItem = () => {
    const generateRandomWidth = () => {
        return `${Math.floor(Math.random() * 61) + 60}%`;
    };
    return <div className='blog-item'>
        <span className='blog-title'>
            <Skeleton width={generateRandomWidth()} />
            <Skeleton width={generateRandomWidth()} />
        </span>
        <div className='blog-meta'>
            <span className='author'><Skeleton width="100px" /></span>
            <span className='category'>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5" r="5" fill="#024953"/>
                </svg>
                <Skeleton width="100px" />
            </span>
        </div>
        <span className='excerpt'>
            <Skeleton width={generateRandomWidth()} />
            <Skeleton width={generateRandomWidth()} />
            <Skeleton width={generateRandomWidth()} />
        </span>
    </div>
}
